<template>
    <el-dialog custom-class="balance-dialog-class"  title="余额详情" :visible.sync="dialogVisible" @close = "closeBalanceDetail" width="900px" :close-on-click-modal="false" :show-close="false">                
        
        <el-card>
            <el-form :model="balanceDetail" label-width="100px">
                <el-form-item label="流水类型：">
                    <el-select class="form-select" @change="getData" v-model="balanceDetail.type" placeholder="请选择流水类型" size="mini">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间：">
                    <el-date-picker @change="getData" class="query-date" size="small" v-model="balanceDetail.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00','23:59:59']"></el-date-picker>
                </el-form-item>
                
            </el-form>
        </el-card>
        <el-table class="table-class" :max-height="editBalanceHeight" :data="balanceDetail.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
            <el-table-column prop="" label="流水类型" >
                <template scope="scope">
                    <el-tag size="mini">{{scope.row.change_kind}}</el-tag>
                </template>
            </el-table-column> 
            <el-table-column prop="old_money" label="交易前金额" ></el-table-column>
            <el-table-column prop="" label="变动金额" >
                <template scope="scope">
                    <span :class="scope.row.change_type == 'IN'?'csuccess':'cdanger'">{{scope.row.change_type == 'IN'?'+':'-'}}{{scope.row.money}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="new_money" label="变动后金额" ></el-table-column>
            <el-table-column prop="auditor" label="操作人" ></el-table-column>
            
            <el-table-column prop="" label="备注" width="180px">
                <template scope="scope">
                    <div size="mini">
                        <div>{{ scope.row.notes }}</div>
                        <div>{{ scope.row.order_id }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="add_time" label="修改时间" ></el-table-column>
            <!-- <el-table-column prop="money" label="数额" >
                <template scope="scope">
                    <span :class="scope.row.change_type == 'IN'?'cprimary':'cdanger'">{{scope.row.change_type == 'IN'?'+':'-'}}{{scope.row.money}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="notes" label="类型"></el-table-column>                     -->
        </el-table>
        <div class="flexX  pageBox flexEnd">
            <el-pagination :disabled="balanceDetail.loading" @size-change="handleSizeChangeMoney" @current-change="handleCurrentChangeMoney" :current-page="balanceDetail.page" :page-sizes="balanceDetail.pageSizesArr" :page-size="balanceDetail.pageSize" layout="total, sizes, prev, pager, next" :total="balanceDetail.total"></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeBalanceDetail" :disabled="balanceDetail.loading">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="closeBalanceDetail" :disabled="balanceDetail.loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>

export default {
    props: {
        // balanceDetail: {
        //     type: Object,
        //     default: function () {
        //         return {}
        //     }
        // },
        dialogVisible:{
            type: Boolean,
            default: false,
        },
        traderId:{
            type: Number || String,
            default: '',
        },

    },
    data(){
        return{
            editBalanceHeight:0,
            balanceDetail:{
                date:[],
                tableData:[],
                page:1,
                pageSizesArr:[10,50,200,500],
                total:0,
                pageSize: 10,
                loading:false,
                type:'',
                startTime:'',
                endTime:'',
            },
            options:[]
        }
    },
    mounted(){
        console.log('mounted',this.dialogVisible)
        
        this.balanceDetail.date = [this.$util.timestampToTime(new Date().getTime(),true)+' 00:00:00', this.$util.timestampToTime(new Date().getTime(),true)+' 23:59:59']
        this.moneyChangeKindOptions()
        this.getBalanceDetailHeight()
        this.getData()
    },
    methods:{
        //筛选项查询
        moneyChangeKindOptions(){
            this.$api.moneyChangeKindOptions({}).then(res=>{ 
                // console.log(res,'res')
                if(res.status == 1){ 
                    this.options = res.data
                }else{

                }
            })
        },
        closeBalanceDetail(){
            this.$emit('closeBalanceDetail')
        },
        getData(){
            this.balanceDetail.page = 1
            this.moneyChangeList()
        },
        //余额详情
        // getBalanceDetail(item){
        //         this.getBalanceDetailHeight()
        //         this.balanceDetail.visible = true
        //         this.$nextTick(() => {		
        //             this.getDialogTop('balance-dialog-class')
        //         })
                                
        //         this.dialog.form.id=item.id
        //         this.moneyChangeList()
        // },
          //余额详情接口
          moneyChangeList(){
                let data ={
                    "traderId": this.traderId, // 客户id
                    "size": this.balanceDetail.pageSize,
                    "page":  this.balanceDetail.page,
                    "change_kind":this.balanceDetail.type,
                    "startTime": this.balanceDetail.date && this.balanceDetail.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.balanceDetail.date[0])), false) : '', // 下单开始时间
                    "endTime":this.balanceDetail.date && this.balanceDetail.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.balanceDetail.date[1])), false) : '', // 下单结束时间
                    
                }
                this.balanceDetail.loading = true;
                this.$api.moneyChangeList(data).then(res=>{
                    this.getBalanceDetailHeight()
                    this.balanceDetail.loading = false;
                    if(res.status == 1){
                        this.balanceDetail.tableData = res.data.data  
                        this.balanceDetail.total = res.data.total     
                        this.$nextTick(() => {		
                            // this.getDialogTop('balance-dialog-class')
                        })                
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.balanceDetail.loading = false;
                })
            },
            // 余额分页查询数据
            handleSizeChangeMoney(val){
                this.balanceDetail.pageSize = val;
                this.balanceDetail.page = 1
                this.balanceDetail.total = 0
                this.moneyChangeList()
            },
            handleCurrentChangeMoney(val){
                this.balanceDetail.page = val
                this.moneyChangeList()
            },
         //计算余额弹窗内表格高度
         getBalanceDetailHeight(){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    console.log('documentHeight',documentHeight)
                    this.editBalanceHeight =( documentHeight / 2) 
                })
            },
    },
}
</script>
<style lang="scss">
.balance-dialog-class{
    .el-dialog__body{
        padding-top: 0 !important;
    }
    .el-dialog__header{
        padding-bottom: 16px !important;
    }
    .el-form-item{
        margin-bottom: 0 !important;
    }
}
</style>
<style lang="scss" scoped>
.balance-dialog-class{   
    .form-select{
        width: 150px;
    }
    .table-class{
        margin-top: 16px;
    }
    .pageBox{
        padding: 16px 20px;
        border-top: 1px solid #ebeef5;
        background-color: #fafcff;
    }
    
}
    
</style>